import React from 'react';
import styled from 'styled-components';

import { boxShadow } from 'js/config/style';
import AnimatedBox from 'js/components/core/SteppedPage/AnimatedBox';
import Address from './Address';

const Container = styled(AnimatedBox)`
  background: white;
  box-shadow: ${boxShadow};
`;

export default () => (
  <Container>
    <Address />
  </Container>
);
